import { temAcesso } from '@/shared/auth/temAcesso'

const Fiscalizacoes = () => import('./Fiscalizacoes.vue')
const FiscalizacaoForm = () => import('./FiscalizacaoForm.vue')
const FiscalizacaoDetalhar = () => import('./FiscalizacaoDetalhar.vue')
const FiscalizacaoIrregularidadeDetalhar = () => import('./detalheFiscalizacaoIrregularidade/FiscalizacaoIrregularidadeDetalhe.vue')
const FiscalizacaoIrregularidadeAvaliarForm = () => import('./avaliarIrregularidade/AvaliarIrregularidadeForm.vue')
const FiscalizacaoIrregularidadeAvaliacao = () => import(`./historicoAvaliacao/HistoricoAvaliacao.vue`)

export default {
    path: 'fiscalizacoes',
    name: 'Fiscalizações',
    component: Fiscalizacoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('FISCALIZACAO-ADMIN') || temAcesso('FISCALIZACAO-FISCAL')) {
            next()
        }
    },
    children: [
        {
            path: 'inserir',
            name: 'Fiscalizações_Inserir',
            component: FiscalizacaoForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FISCALIZACAO-ADMIN') || temAcesso('FISCALIZACAO-FISCAL')) {
                    next()
                }
            }
        },
        {
            path: 'detalhar/:fiscalizacaoId',
            name: 'Fiscalizações_Detalhar',
            component: FiscalizacaoDetalhar,
            children: [
                {
                    path: 'irregularidade/:idIrregularidadeFiscalizacao',
                    name: 'IrregularidadeFiscalizacao_Detalhe',
                    component: FiscalizacaoIrregularidadeDetalhar,
                    children: [
                        {
                            path: 'avaliacao/:idAvaliacaoIrregularidade',
                            name: 'IrregularidadeFiscalizacao_Avaliacao',
                            component: FiscalizacaoIrregularidadeAvaliacao, 
                            beforeEnter: (to, from, next) => {
                                if (temAcesso('FISCALIZACAO-ADMIN') || temAcesso('FISCALIZACAO-FISCAL')) {
                                    next()
                                }
                            }
                        },
                        {
                            path: 'avaliar',
                            name: 'IrregularidadeFiscalizacao_Avaliar',
                            component: FiscalizacaoIrregularidadeAvaliarForm,
                            beforeEnter: (to, from, next) => {
                                if (temAcesso('FISCALIZACAO-ADMIN') || temAcesso('FISCALIZACAO-FISCAL')) {
                                    next()
                                }
                            }
                        },
                    ],
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('FISCALIZACAO-ADMIN') || temAcesso('FISCALIZACAO-FISCAL')) {
                            next()
                        }
                    }
                },
            ],
            beforeEnter: (to, from, next) => {
                if (temAcesso('FISCALIZACAO-ADMIN') || temAcesso('FISCALIZACAO-FISCAL')) {
                    next()
                }
            }
        },
        {
            path: 'atualizar/:fiscalizacaoId',
            name: 'Fiscalizações_Atualizar',
            component: FiscalizacaoForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FISCALIZACAO-ADMIN') || temAcesso('FISCALIZACAO-FISCAL')) {
                    next()
                }
            }
        },
    ]
}